<template>
    <div>
    <page :name="name"
          :params="params"
          :forms="forms"
          @action-button="actionButton"
          @composition-button-click="onCompositionButtonClick"
    />
    <file-viewer-modal
    v-if="fileModalOpen"
    buttonName='icDetalharArquivo'
    :params="fileModalParams"
    nmIdentificacaoParserFile='CONSUMER_UNIT_FILE'
    @close-modal="closeFileModal"
    />

    </div>
    </template>
<script>
import { JtCrud } from 'jtech-webcomps'
import { Component, Vue } from 'vue-property-decorator'
import FileViewerModal from '../../../components/file-viewer-modal/FileViewerModal.vue'

const { page } = JtCrud

@Component({
  name: 'ServiceRequestServiceOrderAttendantPage',
  components: { page, FileViewerModal },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }

})
class ServiceRequestServiceOrderAttendantPage extends Vue {
  fileModalParams = {}
  fileModalOpen = false

  get nmInterface () {
    return this.interface
  }

  onCompositionButtonClick ({ button, params }) {
    if (button.name != 'icExcluirComposicao') {
      this.fileModalParams = params
      this.fileModalOpen = true
    }
  }

  actionButton (button, params, page) {
    this.$emit('action-button', button, params, page)
  }

  closeFileModal () {
    this.fileModalOpen = false
  }
}
export default ServiceRequestServiceOrderAttendantPage
</script>

    <style>

    </style>
